import React from "react";
import LoginDialogV1 from "./LoginDialogV1";
import LoginDialogV2 from "./LoginDialogV2";
import AuthenticateDialog from "./AuthenticateDialog";

interface LoginDialogProps {
  title: string;
  message: string;
  version: string;
}

const LoginDialog: React.FC<LoginDialogProps> = ({ title, message, version }) => {
  console.log("version", version, process.env.REACT_APP_SECURITY_VERSION, version === "1");

  return version === "1" ? (
    <LoginDialogV1 title={title} message={message} />
  ) : (
    <>
      <AuthenticateDialog
      mode='login'
        title="IDOX ADS Security Authenticate"
        message="Authenticate with the code emailed to you."
      />
      <LoginDialogV2 title={title} message={message} />
    </>
  );
};

export default LoginDialog;
